import React from 'react'
import { Headings, PaddedImage, GenerateLink, PlayBtn } from 'scripts/helpers/AppHelper'
import { FloatMeta, Meta, FloatDate } from './helpers/ThumnailHelpers.jsx'
import { decodeHTML, extractSubType } from 'scripts/lib/utils'

const TitleWithDate = (props) => {
  const {show, title, date, dateHOL} = props
  if (!show) { return null }
  const cssDateOnLarge = dateHOL ? 'small-8 med-12' : 'small-8 med-8'
  const linkProps = Object.assign({...props}, {type: 'post', element: title})
  const titleElement = <GenerateLink {...linkProps} />
  return <div className="row heading-wrapper">
    <div className={`col ${cssDateOnLarge}`}>
      <Headings heading={4} cssClass='media-heading' content={titleElement} />
    </div>
    <FloatDate floatdate={true} date={date} hideOnLarge={dateHOL} />
  </div>
}

const TitleOnly = (props) => {
  const {show, title} = props
  if (!show) { return null }
  const linkProps = Object.assign({...props}, {type: 'post', element: title})
  const titleElement = <GenerateLink {...linkProps} />
  return <div className="heading-wrapper">
    <Headings heading={4} cssClass='media-heading' content={titleElement} />
  </div>
}

const ThumbItem = (props) => {
  const {
    item: {id, slug, images, createdAt: date, associatedWith, title},
    size,
    overlayBadge, overlayBadgeHOL,
    showMeta, showDate, badgeDateHOS,
    titleOnly,
    titleDate, titleDateResponsive, truncate,
    customOnClick
  } = props
  const category = associatedWith ? extractSubType(associatedWith, 'category') : null
  const imageURL = images && images.header ? images.header.url : null
  const titleText = title ? decodeHTML(title.text) : null

  // image
  const imageProps = {
    image: imageURL,
    containerClass: 'thumbnail image-wrapper',
    altText: decodeHTML(titleText)
  }
  const image = <PaddedImage {...imageProps}/>

  return (
    <div className={size ? 'col small-12 med-' + size : 'thumb-items'}>
      <div className="thumbnail-wrapper">
        <FloatMeta floatmeta={overlayBadge} hideOnLarge={overlayBadgeHOL} category={category} customOnClick={customOnClick} />
        <GenerateLink id={id} slug={slug} type="post" title={titleText} element={image} truncate={truncate} customOnClick={customOnClick} />
        <PlayBtn {...props.item} />
      </div>
      <Meta show={showMeta} showDate={showDate} badgeDateHOS={badgeDateHOS} category={category} date={date} customOnClick={customOnClick}/>
      <TitleWithDate show={titleDate} title={titleText} slug={slug} id={id} date={date} dateHOL={titleDateResponsive} truncate={truncate} customOnClick={customOnClick} />
      <TitleOnly show={titleOnly} title={titleText} slug={slug} id={id} truncate={truncate} customOnClick={customOnClick} />
    </div>
  )
}

export default ThumbItem



// WEBPACK FOOTER //
// ./assets/js/components/thumbnail/ThumbItem.jsx